import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import YoutubePlayer from "../../../youtube-player";
class TimelineSelectorsMixin {
    get selectorName() {
        return {
            node: 'timeline',
            card: {
                node: 'timeline-card',
                active: 'timeline-card--is-active'
            }
        }
    }
}
export default class Timeline extends TimelineSelectorsMixin {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.timeline'), el => {
            new Timeline(el);
        });
    }

    constructor(element) {
        if (!element) return;
        super();
        this.cards = [];

        const cardNodes = Array.from(element.querySelectorAll('.' + super.selectorName.card.node));
        cardNodes.forEach(el => {
            this.cards.push(new TimelineCard(el));
        });

        window.addEventListener('resize', e => {
            let playerNodeWrapper = document.querySelector('.pswp .pswp__youtube-player-container');
            if (!playerNodeWrapper) return;

            let contentElement = playerNodeWrapper.parentNode.querySelector('.pswp__img');
            playerNodeWrapper.style.height = contentElement.style.height;
            playerNodeWrapper.style.width = contentElement.style.width;
            setTimeout(() => {
                playerNodeWrapper.style.height = contentElement.style.height;
                playerNodeWrapper.style.width = contentElement.style.width;
            }, 100);
        })
    }
}

class TimelineCard extends TimelineSelectorsMixin {
    elementNode = null;

    constructor(element) {
        if (!element) return;
        super();

        this.player = null;
        this.elementNode = element;
        const lightbox = new PhotoSwipeLightbox({
            gallery: this.elementNode.querySelector('.pswp-gallery'),
            children: 'a',
            showAnimationDuration: 500,
            hideAnimationDuration: 500,
            pswpModule: PhotoSwipe,
            maxZoomLevel: 1,
            wheelToZoom: false,
        });

        let createPlayer = (content) => {
            let zoomWrapper = content.element.parentNode;
            if (!zoomWrapper || zoomWrapper.querySelector('.pswp__youtube-player-container')) return;

            const playerNodeWrapper = document.createElement('div');
            playerNodeWrapper.className = 'pswp__youtube-player-container';

            const playerNode = this.elementNode.querySelector('.youtube-player').cloneNode(true);
            playerNode.style.opacity = 0;
            playerNodeWrapper.appendChild(playerNode);
            playerNodeWrapper.style.height = content.element.style.height;
            playerNodeWrapper.style.width = content.element.style.width;
            zoomWrapper.appendChild(playerNodeWrapper);
            const newPlayer = zoomWrapper.querySelector('.youtube-player');
            this.player = new YoutubePlayer(newPlayer);

            this.player.element.addEventListener('playing', (e) => {
                if (this.player && e.detail.player.options.videoId === this.player.player.options.videoId) {
                    this.player.element.style.opacity = 1;
                }
            });
        }

        lightbox.on('initialZoomInEnd', () => {
            let type = lightbox.pswp.currSlide.data.element.dataset.type;
            let content = lightbox.pswp.currSlide.content;

            if (type === 'video') {
                createPlayer(content);
                if (this.player.state === 'unstarted' || this.player.state === 'ended' || this.player.state === 'paused') {
                    this.player.startPlayer();
                }
            }
        });

        lightbox.on('change', () => {
            let type = lightbox.pswp.currSlide.data.element.dataset.type;
            let content = lightbox.pswp.currSlide.content;
            let zoomButton = lightbox.pswp.element.querySelector('.pswp__button--zoom');
            if (type === 'video') {
                createPlayer(content);
                zoomButton.style.display = 'none';
                if (this.player) this.player.element.style.opacity = 1;
            } else {
                if (this.player && this.player.state !== 'ended' && this.player.state !== 'unstarted') {
                    this.player.YTStop();
                }
                zoomButton.style.display = 'block';
            }
        });

        lightbox.init();

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            this.activate();
            return;
        }
        window.addEventListener('scroll', () => this.onScroll());
        this.onScroll();
    }

    onScroll() {
        this[this.inViewport(this.elementNode) ? 'activate' : 'deactivate']();
    }

    activate() {
        this.elementNode.classList.add(super.selectorName.card.active);
    }

    deactivate() {
        this.elementNode.classList.remove(super.selectorName.card.active);
    }

    inViewport(el) {
        let rect = el.getBoundingClientRect();

        return (
            rect.top + rect.height / 3 >= 0 &&
            rect.left + rect.width / 3 >= 0 &&
            (rect.bottom - rect.height / 3) <= (window.innerHeight || document.documentElement.clientHeight) &&
            (rect.right - rect.width / 3) <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}
